import React, { Component } from 'react';

import { Markdown, Button } from "grommet";
import { Helmet } from "react-helmet";
import LoginComponent from "../../components/Login";

// import { SecretClient } from "@azure/keyvault-secrets";


class ReleaseNotesPage extends Component {

  constructor() {
    super();
    this.state = {
      releasenotes: []
    };
    this.setLogin = this.setLogin.bind(this);
    this.account = "analyticsdiag870";
    this.blob = "ReleaseNotes";
    this.container = "mdsettingsandexperiments";
  }

  async setLogin() {

    const { BlobServiceClient } = await import(/* webpackChunkName: "@azure/storage-blob" */ '@azure/storage-blob');

    // Enter your storage account name
    const defaultAzureCredential = this.props.defaultAzureCredential;

    // key-vault currently doesn't work, because it doesn't support CORs :(
    // see https://feedback.azure.com/forums/906355-azure-key-vault/suggestions/34753195-enable-cors-for-key-vault
    // const client = new SecretClient("https://.....vault.azure.net/", defaultAzureCredential);
    // const latestSecret = await client.getSecret("....");
    // console.log("latestSecret", latestSecret);

    const blobServiceClient = new BlobServiceClient(
      `https://${this.account}.blob.core.windows.net`,
      defaultAzureCredential
    );
    const containerClient = blobServiceClient.getContainerClient(this.container);
    const releasenotes = [];
    for await (const blob of containerClient.listBlobsFlat({ prefix: this.blob })) {
        console.log('\t', blob.name);
        const blockBlobClient = containerClient.getBlockBlobClient(blob.name);
        const downloadBlockBlobResponse = await blockBlobClient.download(0);
        const blobc = await downloadBlockBlobResponse.blobBody;
        const releasenote = await blobc.text();
        releasenotes.push(releasenote);
    }

    this.setState({ releasenotes });
  }

  componentDidMount() {
    if(!this.state.releasenotes.length) {
      this.setLogin();
    }
  }

  render() {

    return !this.state.releasenotes.length ? (<div>
      <p>Loading....</p>
    </div>) : (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Release Notes - MD Dashboard</title>
        </Helmet>
        {this.state.releasenotes.reverse().map((rn, idx) => {
          const lines = rn.split("\n");
          const version = lines[lines.length - 2].split(": ").pop().replace(/\\n/g, "");
          return (<>
            <details id={version}>
                <summary>Release {version}</summary>
                <Markdown key={`release-${idx}`}>{rn.replace(/\\n/g, "\n")}</Markdown>
            </details><hr/>
          </>);
        })}
      </div>
    );
  }
}

export default () => {
  return <LoginComponent>{({ defaultAzureCredential }) => (<ReleaseNotesPage defaultAzureCredential={defaultAzureCredential} />)}</LoginComponent>
}
